//@flow
import * as React from 'react'
import { Field } from 'redux-form'
import RFCheckboxField from '../../../components/ReduxFormComps/RFCheckboxField';
import renderTextField from '../../../components/MaterialUi/renderTextField';
import styles from './styles'
import { checkboxCustomStyle,checkboxCustomLabelStyle } from '../../ProjectApollo/CheckboxUtil';
import type { ContainerRowReduxHideTextFieldOverride$Props } from '../flowTypes'

const textOnChange=(e,props:ContainerRowReduxHideTextFieldOverride$Props)=>{
    if (props.textOnChangeFunc){
        const textOnChangeFunc = props.textOnChangeFunc
        const parentProps = (props.parentProps:any)
        textOnChangeFunc(e,parentProps)
    }
}

const checkboxOnChange=(e,props)=>{
    if (props.checkboxOnChangeFunc){
        const checkboxOnChangeFunc = props.checkboxOnChangeFunc
        const parentProps = (props.parentProps:any)
        checkboxOnChangeFunc(e,parentProps)
    }
}

const ContainerRowReduxHideTextFieldIfOverride=(props:ContainerRowReduxHideTextFieldOverride$Props)=>{
    const childComponents = []

    const textFieldComponent = (
        <Field
            key={`${props.textField}`}
            name={props.textField}
            component={renderTextField}
            label={props.textLabel}
            style={props.textType && props.textType==='number'?styles.numberFieldStyle:styles.textFieldStyle}
            type={props.textType?props.textType:'string'}
            onChange={(e)=> textOnChange(e,props)}
        />
    )

    if (!props.isOverride){
        childComponents.push(textFieldComponent)
    }
    
    const checkboxFieldComponent = (
        <Field 
            key={`${props.checkboxField}`}
            name={props.checkboxField} 
            component={RFCheckboxField} 
            label={props.checkboxLabel}
            customStyle={checkboxCustomStyle}
            customLabelStyle={checkboxCustomLabelStyle(props.isOverride)}
            onChange={(e)=>checkboxOnChange(e,props)}
        />
    )

    childComponents.push(checkboxFieldComponent)
       
    return (
        <div className="row">
            <div className="col-sm">
                {childComponents}
            </div>
        </div>
    )
}

export default ContainerRowReduxHideTextFieldIfOverride


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/common/ContainerRowReduxHideTextFieldIfOverride.js